module.exports = __webpack_public_path__ + "img/uploaded-excel.7892e49f.png";